export const Heading1Style = 'text-3xl font-extrabold mt-4 mb-8 dark:text-customGray-lightest'